(() => {

  const control = document.getElementById('toggle-dark-mode');

  let theme = localStorage.getItem('theme');
  let prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  let prefersLightMode = window.matchMedia('(prefers-color-scheme: light)').matches;

  const enableDarkMode = () => {
    if (theme === 'light' || !theme && prefersLightMode) {
      return true;
    } else {
      return false;
    }
  }

  const toggleClasses = (theme) => {
    let namespace = `theme`;
    let oppositeTheme = ((theme === 'dark') ? 'light' : 'dark');

    document.body.classList.remove(`${namespace}-${oppositeTheme}`);
    document.body.classList.add(`${namespace}-${theme}`);
  }

  if (theme) {
    toggleClasses(theme);
  }

  control.setAttribute('aria-checked', !enableDarkMode());

  control.addEventListener('click', () => {
    theme = (enableDarkMode() ? 'dark' : 'light');
    localStorage.setItem('theme', theme);
    control.setAttribute('aria-checked', !enableDarkMode());
    toggleClasses(theme);
  });
})();
